import React from "react";

import { Grid } from "@mui/material";

import { BackButton } from "../BackButton";
import { Template } from "../Template";

import { PreviousThreads } from "./PreviousThreads";

export const ChoosePreviousThread = () => {
  return (
    <Template
      leftNode={<PreviousThreads />}
      rightNode={
        <Grid container item columnSpacing={1} sx={{ marginBottom: "auto" }}>
          <Grid item>
            <BackButton />
          </Grid>
        </Grid>
      }
    />
  );
};
